import styled, { css} from 'styled-components';

export const Content = styled.div`
  border: 1px solid #8e8e8e;
  border-radius: 6px;
  /* font-weight: 400; */
  /* font-size: 0.875rem; */
  line-height: 1.43;
  letter-spacing: 0.01071em;
  display: flex;
  /* margin: 16px 0 0px !important; */
  padding: 8px 16px 8px 40px;
  /* color: rgb(30, 70, 32); */
  background-color: #edf7ed;
  position: relative;
  .icon {
    position: absolute;
    left: 8px;
    top: 8px;
  }
  ${props => props.theme.theme === 'dark' && css`
    
  background-color: #393e44;
  `}
`
